import { SvgIconType } from './svg.interface';

const LabTest: SvgIconType = ({
  width = 12,
  height = 12,
  className = '',
  color = '#3AA5DC'
}) => (
  <div>
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.74982 1.5V5.03898C3.74982 5.17698 3.71174 5.31231 3.63978 5.43006L0.322153 10.8589C0.0167411 11.3587 0.376417 12 0.962114 12H11.0375C11.6232 12 11.9829 11.3587 11.6775 10.8589L8.35986 5.43006C8.2879 5.31231 8.24982 5.17698 8.24982 5.03898V1.5H8.99982V0H2.99982V1.5H3.74982ZM4.13274 7.5H7.8669L7.07994 6.21224C6.86405 5.85897 6.74982 5.45299 6.74982 5.03898V1.5H5.24982V5.03898C5.24982 5.45299 5.13559 5.85897 4.91971 6.21224L4.13274 7.5ZM6.0998 9.375C6.0998 9.99632 5.59612 10.5 4.9748 10.5C4.35348 10.5 3.8498 9.99632 3.8498 9.375C3.8498 8.75368 4.35348 8.25 4.9748 8.25C5.59612 8.25 6.0998 8.75368 6.0998 9.375ZM7.5998 11.25C8.01402 11.25 8.3498 10.9142 8.3498 10.5C8.3498 10.0858 8.01402 9.75 7.5998 9.75C7.18559 9.75 6.8498 10.0858 6.8498 10.5C6.8498 10.9142 7.18559 11.25 7.5998 11.25Z"
        fill={color}
      />
    </svg>
  </div>
);

export default LabTest;
